import { render, staticRenderFns } from "./ProductShare.vue?vue&type=template&id=6046c84c&lang=pug&"
import script from "./ProductShare.vue?vue&type=script&lang=js&"
export * from "./ProductShare.vue?vue&type=script&lang=js&"
import style0 from "./ProductShare.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6046c84c')) {
      api.createRecord('6046c84c', component.options)
    } else {
      api.reload('6046c84c', component.options)
    }
    module.hot.accept("./ProductShare.vue?vue&type=template&id=6046c84c&lang=pug&", function () {
      api.rerender('6046c84c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/basic/ProductShare.vue"
export default component.exports